<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-back-button defaultHref="/"></ion-back-button>
        </ion-buttons>
        <ion-title>{{ 'Team Events' | translate }}</ion-title>
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-refresher #refresher (ionRefresh)="doRefresh()" slot="fixed">
        <ion-refresher-content></ion-refresher-content>
    </ion-refresher>

    @defer (when loaded()) {
        @if (leagues().length) {
            @for (league of leagues(); track $index) {
                <ion-router-link [routerLink]="['/leagues', league.urlSegment]" routerDirection="forward" style="display:block">
                    <ion-card class="content-width">
                        <ion-card-header>
                            @if (league.startDate) {
                                <ion-card-subtitle>
                                    {{ league.startDate | date: 'longDate' }} - {{ league.endDate | date: 'longDate' }}
                                </ion-card-subtitle>
                            }
                        <ion-card-title>{{ league.name }}</ion-card-title>
                        </ion-card-header>
                        <ion-card-content>
                            Teams: {{ league.teams.length }} | Matches: {{ league.ties.length }}
                        </ion-card-content>
                    </ion-card>
                </ion-router-link>
            }
        } @else {
            <app-empty-page [text]="noLeaguesText" iconName="tennisball"></app-empty-page>
        }
    } @loading (minimum 0.6s) {
        @for (x of [].constructor(5); track $index) {
            <div class="ion-padding content-width">
                <ion-skeleton-text animated style="width: 100%"></ion-skeleton-text>
                <ion-skeleton-text animated style="width: 100%"></ion-skeleton-text>
            </div>
        }
    } @placeholder {
        <app-empty-page [text]="noTeamEventsText" iconName="trophy"></app-empty-page>
    }
    
    @if (authService.authUserSignal()) {
        <ion-fab vertical="bottom" horizontal="end" slot="fixed">
            <ion-fab-button color="primary" (click)="createLeague()">
                <ion-icon name="add"></ion-icon>
            </ion-fab-button>
        </ion-fab>
    }

</ion-content>

<ion-footer>
    <ion-toolbar>
        <ion-item lines="none" color="light">
            <ion-toggle [(ngModel)]="isPublic" (ngModelChange)="doRefresh()" justify="space-between">{{'Public events' | translate}}</ion-toggle>
        </ion-item>
    </ion-toolbar>
</ion-footer>